import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { BenefitsPage } from './pages/BenefitsPage';
import { PartnersPage } from './pages/PartnersPage';
import { ContactPage } from './pages/ContactPage';
import { PresentationsPage } from './pages/PresentationsPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/about" element={<AboutPage data-id="element-7" />} data-id="element-6" />
          <Route path="/benefits" element={<BenefitsPage data-id="element-9" />} data-id="element-8" />
          <Route path="/partners" element={<PartnersPage data-id="element-11" />} data-id="element-10" />
          <Route path="/presentations" element={<PresentationsPage data-id="element-13" />} data-id="element-12" />
          <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
        </Route>
      </Routes>
    </Router>;
}